"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nullDocs = void 0;
var nullDocs = exports.nullDocs = {
  name: 'null',
  category: 'Constants',
  syntax: ['null'],
  description: 'Value null',
  examples: ['null'],
  seealso: ['true', 'false']
};